import type { PricesEntry } from '@cocoonspace/sdk-js/types/pricesEntry'
import type { Space } from '@cocoonspace/sdk-js/types/space'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { fr } from 'date-fns/locale'
import { Trans, useTranslation } from 'next-i18next'
import { useMemo } from 'react'
import { Calendar } from '~/components/ui/calendar'
import { styles } from '~/domains/booking/components/organisms/details-sidebar-step-month'

const locales = {
	fr,
}

export const BookingSidebarMultidateCalendar = ({
	space,
	bookingOptions,
	calendarPrices,
	daysPrices,
	maxDate,
	onSelect,
}: {
	space?: Space
	bookingOptions: Date[]
	calendarPrices: PricesEntry[]
	daysPrices: Record<string, PricesEntry>
	maxDate: string
	// * SelectMultipleEventHandler
	onSelect: (date: Date[] | undefined) => void
}) => {
	const { i18n } = useTranslation()

	const maxDateNative = useMemo(
		() => dateTimeUtils(maxDate).toDate(),
		[maxDate],
	)

	const disabled = useMemo(() => {
		return calendarPrices
			?.filter(({ closed, available }) => closed || available === false)
			.map(({ day }) => dateTimeUtils(day).tz(space?.timezone).toDate())
	}, [space?.timezone, calendarPrices])

	return (
		<div className='max-h-[478px] w-full overflow-x-hidden overflow-y-scroll overscroll-contain pt-[30px] pb-4'>
			<Calendar
				locale={locales[(i18n.language as 'fr') || 'fr']}
				disableNavigation
				classNames={styles}
				numberOfMonths={13}
				fromDate={dateTimeUtils().toDate()}
				toDate={maxDateNative}
				selected={bookingOptions}
				mode='multiple'
				disabled={disabled}
				components={{
					DayContent: ({ date }) => {
						const currentDay = dateTimeUtils(date).customFormat('dateTech')
						const currentPrice = daysPrices[currentDay]
						const price =
							currentPrice?.price_day_discounted ?? currentPrice?.price_day

						const priceTrad = !!Number(price?.toString().slice(-2)) // if decimals -> full variant
							? 'common:currency.full'
							: 'common:currency.short'

						return (
							<div className='flex flex-col gap-y-1 leading-none'>
								{date.getDate()}

								{price !== undefined && (
									<Trans
										parent='div'
										i18nKey={priceTrad}
										values={{ val: price / 100 }}
										className='text-xxs leading-none'
									/>
								)}
							</div>
						)
					},
				}}
				onSelect={onSelect}
			/>
		</div>
	)
}
